export const getAddress = (order = {}) =>
  [
    order.address_lot ? `LOT ${order.address_lot}` : '',
    order.address_unit ? `${order.address_unit} /` : '',
    order.address_street_no || '',
    order.address_street_1 || '',
    order.address_street_2 || '',
    order.address_suburb || '',
    order.address_state || '',
    order.address_postcode || ''
  ]
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

export default getAddress;
